export default __webpack_public_path__ + "static/media/Bub.4cfa8a8e.png";